import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import { UpsertSiteDailyReportBody, SiteDailyReportResponse, upsertSiteDailyReport } from '../../services/apiSLTP/dailyReports/siteDailyReports';

type UseUpsertSiteDailyReportMutationOptions = MutationOptions<SiteDailyReportResponse, Error, UpsertSiteDailyReportBody>;

export const useUpsertSiteDailyReportMutation = (options?: UseUpsertSiteDailyReportMutationOptions) => {
    const siteDailyReportMutation: MutationFunction<SiteDailyReportResponse, UpsertSiteDailyReportBody> = async (data) => {
        try {
            const response: SiteDailyReportResponse = await upsertSiteDailyReport(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during site daily report upsert');
        }
    };

    return useMutation(siteDailyReportMutation, options);
};
